/**
 * Application Access Manager Entry Point
 */

// Import styles - REQUIRED for proper formatting
import '../styles/index.scss';

// Import core utilities and components for sidebar/theme functionality
import { DOM } from './utils/dom.js';
import ThemeManager from './utils/theme.js';
import Sidebar from './components/Sidebar.js';
import authService from './auth/authService.js';

// Import scrollbar for sidebar
import './scrollbar';

// Import Application Access Manager
import { initApplicationAccessManager } from '../../components/access/ApplicationAccessManager.js';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  // Hide the loader
  const loader = document.getElementById('loader');
  if (loader) {
    setTimeout(() => {
      loader.style.transition = 'opacity 0.3s ease-in-out';
      loader.style.opacity = '0';
      setTimeout(() => {
        loader.style.display = 'none';
      }, 300);
    }, 100);
  }
  
  // Initialize core components (sidebar, theme, etc.)
  if (DOM.exists('.sidebar')) {
    new Sidebar();
  }
  
  // Initialize theme manager
  ThemeManager.init();
  
  // Initialize navigation dropdowns
  const dropdownToggles = document.querySelectorAll('.nav-item.dropdown > .dropdown-toggle');
  
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = toggle.parentElement;
      const menu = parent.querySelector('.dropdown-menu');
      const arrow = toggle.querySelector('.arrow');
      
      // Toggle current dropdown
      const isOpen = parent.classList.contains('open');
      
      // Close all dropdowns first
      document.querySelectorAll('.nav-item.dropdown').forEach(item => {
        item.classList.remove('open');
        const itemArrow = item.querySelector('.arrow');
        if (itemArrow) {
          itemArrow.style.transform = '';
        }
      });
      
      if (!isOpen) {
        parent.classList.add('open');
        if (menu) {
          menu.style.display = 'block';
        }
        if (arrow) {
          arrow.style.transform = 'rotate(90deg)';
        }
      } else {
        if (menu) {
          menu.style.display = 'none';
        }
      }
    });
  });
  
  // Auto-expand current dropdown if page is in a dropdown menu
  const currentPath = window.location.pathname.split('/').pop();
  document.querySelectorAll('.nav-item.dropdown .dropdown-menu .sidebar-link').forEach(link => {
    const linkPath = link.getAttribute('href');
    if (linkPath === currentPath) {
      const dropdown = link.closest('.nav-item.dropdown');
      if (dropdown) {
        dropdown.classList.add('open');
        const menu = dropdown.querySelector('.dropdown-menu');
        if (menu) {
          menu.style.display = 'block';
        }
        const arrow = dropdown.querySelector('.arrow');
        if (arrow) {
          arrow.style.transform = 'rotate(90deg)';
        }
      }
    }
  });
  
  // Initialize header dropdowns
  const headerDropdownToggles = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  
  headerDropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const menu = toggle.nextElementSibling;
      if (menu && menu.classList.contains('dropdown-menu')) {
        menu.classList.toggle('show');
      }
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.dropdown')) {
      document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
        menu.classList.remove('show');
      });
    }
  });
  
  // Initialize logout handlers
  const logoutBtn = document.getElementById('logoutBtn');
  const headerLogoutBtn = document.getElementById('headerLogoutBtn');
  
  if (logoutBtn) {
    logoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      authService.logout();
    });
  }
  
  if (headerLogoutBtn) {
    headerLogoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      authService.logout();
    });
  }
  
  // Initialize the Application Access Manager
  initApplicationAccessManager();
});